export default __webpack_public_path__ + "static/tel-b4c4787789e0c314360bf76ba384d19a.svg";